
import { useEffect, useState } from 'react';
import { ClientLogo } from '../../../types/client';

export default function TrustedPartners() {
  const [clients, setClients] = useState<ClientLogo[]>([]);

  useEffect(() => {
    const saved = localStorage.getItem('clientLogos');
    if (saved) {
      setClients(JSON.parse(saved));
    }
  }, []);

  const row1Clients = clients.filter(c => c.row === 1).sort((a, b) => a.order - b.order);
  const row2Clients = clients.filter(c => c.row === 2).sort((a, b) => a.order - b.order);

  // Duplicate for seamless loop
  const row1Items = [...row1Clients, ...row1Clients, ...row1Clients];
  const row2Items = [...row2Clients, ...row2Clients, ...row2Clients];

  if (clients.length === 0) {
    return null;
  }

  return (
    <div className="py-12 bg-white border-y border-gray-100 overflow-hidden">
      <div className="container mx-auto px-6 text-center mb-8">
        <p className="text-xs text-gray-400 font-bold tracking-widest">TRUSTED BY MARKET LEADERS</p>
      </div>

      <div className="space-y-8">
        {/* Row 1 - Scroll Left to Right */}
        {row1Clients.length > 0 && (
          <div className="relative">
            <div className="flex animate-scroll-right gap-12">
              {row1Items.map((client, index) => (
                <div
                  key={`${client.id}-${index}`}
                  className="flex-shrink-0 w-48 h-24 flex items-center justify-center grayscale hover:grayscale-0 opacity-60 hover:opacity-100 transition-all duration-300"
                >
                  <img
                    src={client.logoUrl}
                    alt={client.name}
                    className="max-w-full max-h-full object-contain"
                  />
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Row 2 - Scroll Right to Left */}
        {row2Clients.length > 0 && (
          <div className="relative">
            <div className="flex animate-scroll-left gap-12">
              {row2Items.map((client, index) => (
                <div
                  key={`${client.id}-${index}`}
                  className="flex-shrink-0 w-48 h-24 flex items-center justify-center grayscale hover:grayscale-0 opacity-60 hover:opacity-100 transition-all duration-300"
                >
                  <img
                    src={client.logoUrl}
                    alt={client.name}
                    className="max-w-full max-h-full object-contain"
                  />
                </div>
              ))}
            </div>
          </div>
        )}
      </div>

      <style>{`
        @keyframes scroll-right {
          0% {
            transform: translateX(-33.333%);
          }
          100% {
            transform: translateX(0%);
          }
        }

        @keyframes scroll-left {
          0% {
            transform: translateX(0%);
          }
          100% {
            transform: translateX(-33.333%);
          }
        }

        .animate-scroll-right {
          animation: scroll-right 30s linear infinite;
        }

        .animate-scroll-left {
          animation: scroll-left 30s linear infinite;
        }

        .animate-scroll-right:hover,
        .animate-scroll-left:hover {
          animation-play-state: paused;
        }
      `}</style>
    </div>
  );
}
